// @flow
import React, { Component } from "react";
import I18n from "../../../../i18n/I18n";
import { Dropdown } from "../../../common";
import styles from "./WarehouseBox.scss";

// type Props = {
//   name: string,
//   indeterminate: boolean
// };

class WarehouseBox extends Component {
  state = {
    quantity: this.props.data.quantity ? Number(this.props.data.quantity) : 0,
    stock_updated: 0,
    processing_time_updated: !this.props.data.processing_time,
    processing_time:
      this.props.initialVal &&
      !this.props.initialVal.processing_time &&
      this.props.offerCode
        ? "1"
        : String(this.props.data.processing_time) || "1",
    id_warehouse: this.props.data.id_warehouse || "",
    warehouse_code: this.props.data.warehouse_code || "",
    warehouse_city: this.props.data.warehouse_city || ""
  };
  componentWillReceiveProps(nextProps) {
    if (this.props.data !== nextProps.data) {
      this.setState({ ...nextProps.data });
    }
  }
  inputChange = e => {
    const newState = this.state;
    newState[e.target.name] = e.target.value;
    newState.stock_updated =
      e.target.value !== this.props.data.stock_available ? 1 : 0;
    newState[e.target.name] = e.target.value.replace(/\D/g, "");

    this.setState(newState);
    this.props.valAppend(newState);
  };
  dropdownChange(e: Object, key: any) {
    const newState = this.state;
    newState[`${key}`] = e.value;
    this.setState(newState);
    this.props.valAppend(newState);
  }
  render() {
    let processingTimeOptions = [
      { value: "1", label: I18n.getText("offer.same-day", {}, "Same Day") },
      { value: "2", label: I18n.getText("offer.1-day", {}, "1 Day") },
      { value: "3", label: I18n.getText("offer.2-days", {}, "2 Days") },
      { value: "4", label: I18n.getText("offer.3-days", {}, "3 Days") }
    ];
    let notfound = true;
    for (let i = 0; i < processingTimeOptions.length; i++) {
      if (
        Number(processingTimeOptions[i].value) ===
        Number(this.state.processing_time)
      ) {
        notfound = false;
        break;
      }
    }
    if (notfound && Number(this.state.processing_time)) {
      processingTimeOptions.push({
        value: this.state.processing_time,
        label: I18n.getText("offer.n-days", {
          days: Number(this.state.processing_time) - 1
        })
      });
    }
    const { data } = this.props;
    return (
      <div
        className={`${styles.ctr} ${
          this.props.horizontal ? styles.flexer : ""
        } ${this.props.single ? styles.single : ""}`}
      >
        <div className={styles.attrVal}>
          <div className={styles.eachAttr}>
            <h6 className={styles.attrTitle}>
              {I18n.getText("offer.warehouse-code")}
            </h6>
            <div className={styles.attrVal}>
              <div className={styles.attrVal}>{data.warehouse_code}</div>
            </div>
          </div>
          <div className={styles.eachAttr}>
            <h6 className={styles.attrTitle}>
              {I18n.getText("offer.warehouse-city")}
            </h6>
            <div className={styles.attrVal}>
              <div className={styles.attrVal}>{data.warehouse_city}</div>
            </div>
          </div>
          <div className={styles.eachAttr}>
            <h6 className={styles.attrTitle}>{I18n.getText("variants.qty")}</h6>
            <div className={styles.attrVal}>
              <div className={styles.stockWrapper}>
                <input
                  type="tel"
                  value={data.quantity}
                  name="quantity"
                  disabled={this.props.data.is_fbn}
                  className={`${styles.stockInput} ${
                    this.props.qtyError ? styles.errorInput : ""
                  }`}
                  onChange={this.inputChange}
                />
              </div>
            </div>
          </div>
          <div className={styles.eachAttr}>
            <h6 className={styles.attrTitle}>
              {I18n.getText("offer.processing-time")}
            </h6>
            <div className={styles.attrVal}>
              <div className={styles.attrVal}>
                <div
                  className={`${styles.dropdownWrapper} ${
                    this.props.horizontal ? styles.horizontal : ""
                  }`}
                >
                  {I18n.getComponent(
                    formattedValue => (
                      <Dropdown
                        options={processingTimeOptions}
                        height="short"
                        placeholder={formattedValue}
                        creatable
                        disabled={this.props.data.is_fbn}
                        value={this.state.processing_time}
                        onChange={e =>
                          this.dropdownChange(e, "processing_time")
                        }
                      />
                    ),
                    "dropdown.select"
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default WarehouseBox;



// WEBPACK FOOTER //
// ./src/components/products/offerDetails/warehouseBox/WarehouseBox.js